import { ESGUpdateYear } from 'modules/ESG/types';
import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

export const fetchESGScoreSummaryTab = (id: string, params?: ESGUpdateYear) => {
  const url = `/esg/api/${id}/summary-tab/`;

  return fetchApi(url, { query: params }).then(getFetchApiJSONResponse).catch(catchFetchApiError);
};
